module.exports = __webpack_public_path__ + "img/news-slider1-ja.cd6f2a00.jpg";